<!-- src/components/layout/Footer.svelte -->
<script>
  const current_year = new Date().getFullYear();
</script>

<footer class="site_footer">
  <div class="footer_container">
    <div class="footer_content">
      <div class="footer_section">
        <h3>Down to Earth Guides</h3>
        <p>Making complex topics simple and accessible for business leaders.</p>
      </div>
      
      <div class="footer_section">
        <h3>Legal</h3>
        <ul class="footer_links">
          <li><a href="/privacy">Privacy Policy</a></li>
          <li><a href="/terms">Terms of Service</a></li>
        </ul>
      </div>
    </div>
    
    <div class="footer_bottom">
      <p>&copy; {current_year} Down to Earth Guides. All rights reserved.</p>
    </div>
  </div>
</footer>

<style>
  .site_footer {
    background: #f8f9fa;
    padding: 4rem 0 2rem;
    margin-top: 4rem;
    content-visibility: auto;
    contain-intrinsic-size: 300px; /* Approximate height placeholder */
  }

  .footer_container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 2rem;
  }

  .footer_content {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 2rem;
    margin-bottom: 2rem;
  }

  .footer_section h3 {
    color: #333;
    margin-bottom: 1rem;
    font-size: 1.2rem;
  }

  .footer_section p {
    color: #666;
    line-height: 1.6;
  }

  .footer_links {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .footer_links li {
    margin-bottom: 0.5rem;
  }

  .footer_links a {
    color: #666;
    text-decoration: none;
    transition: color 0.2s ease;
  }

  .footer_links a:hover {
    color: #0066cc;
  }

  .footer_bottom {
    border-top: 1px solid #ddd;
    padding-top: 2rem;
    text-align: center;
    color: #666;
  }
  
  @media (max-width: 768px) {
    .site_footer {
      contain-intrinsic-size: 400px;
    }
  }
</style> 